import { ProductListPage as SourceProductListPage } from 'SourceComponent/ProductListPage/ProductListPage.component';
import { withRouter } from 'react-router-dom';
import ProductCard from 'Component/ProductCard';
import React from 'react';
import Html from 'Component/Html';

export class ProductListPage extends SourceProductListPage {
    renderPageItems() {
        const {
            items,
            selectedFilters,
            category,
            pageNumber
        } = this.props;
        return items.map((product, i) => {
            if (category?.category_banner_1_enabled && pageNumber === 1 && i === parseInt(category?.category_banner_1_position)) {
                return (
                    <>
                        <li className='ProductCard CategoryBanner'>
                            <Html content={ category?.category_banner_1 } />
                        </li>
                        <ProductCard
                            product={ product }
                            key={ i }
                            selectedFilters={ selectedFilters }
                        />
                    </>
                );
            } else if (category?.category_banner_2_enabled && pageNumber === 1 && i === parseInt(category?.category_banner_2_position)) {
                return (
                    <>
                        <li className='ProductCard CategoryBanner'>
                            <Html content={ category?.category_banner_2 } />
                        </li>
                        <ProductCard
                            product={ product }
                            key={ i }
                            selectedFilters={ selectedFilters }
                        />
                    </>
                );
            } else {
                return (
                    <ProductCard
                        product={ product }
                        key={ i }
                        selectedFilters={ selectedFilters }
                    />
                );
            }
        });
    }

    render() {
        const {
            isWidget,
            pageNumber,
            wrapperRef,
            mix
        } = this.props;

        const ProductListPageMarkup = (
            <ul
                block="ProductListPage"
                mix={{ ...mix, elem: 'Page' }}
                key={ pageNumber }
                ref={ wrapperRef }
            >
                { this.renderItems() }
            </ul>
        );

        if (isWidget) {
            return (
                <div block="ProductListWidget" elem="Container">
                    { ProductListPageMarkup }
                </div>
            );
        }

        return ProductListPageMarkup;
    }

    // Override the observer methods so they do NOT trigger auto‑loading:
    componentDidMount() {
        // Start the observer but do not call updatePages().
        this.startObserving();
    }

    componentDidUpdate() {
        this.startObserving();
    }

    startObserving() {
        const { items, updatePages, isInfiniteLoaderEnabled } = this.props;

        // Only create the observer if infinite loading is enabled and no items are loaded.
        // (We want the observer to run only for updating the URL on scroll, not auto-loading.)
        if (!isInfiniteLoaderEnabled || items.length) {
            return;
        }

        if (this.node && !this.observer && 'IntersectionObserver' in window) {
            const options = {
                rootMargin: '0px',
                threshold: 0.1
            };

            this.observer = new IntersectionObserver(([{ intersectionRatio }]) => {
                // We remove or comment out the auto-loading call.
                // Original code:
                // if (intersectionRatio > 0 && !items.length && !this.props.isLoading) {
                //     this.stopObserving();
                //     updatePages();
                // }
                // Instead, do nothing.
            }, options);

            this.observer.observe(this.node);
        }
    }
}

export default withRouter(ProductListPage);
